var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"white"},[_c('hr'),_c('p',[_vm._v(" "+_vm._s(_vm.$t('misc.license'))+" "),_c('a',{attrs:{"href":"https://tiefox.de/"}},[_vm._v("Tiefox.de")])])])}
var staticRenderFns = []

export { render, staticRenderFns }